import { atom } from "recoil";

export const updatePartnerDrawerState = atom({
  key: "updatePartnerDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
